//
// $FlowFixMe
import styled, { css } from 'styled-components';
import { FlexRow } from '../../globals';
import theme from 'shared/theme';
import { PrimaryButton } from 'src/components/button';
import { zIndex } from 'src/components/globals';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  flex: 1 0 auto;
  padding: 0 24px 24px;
`;

export const Actions = styled(FlexRow)`
  margin-top: 24px;
  justify-content: center;

  button + button {
    margin-left: 8px;
  }
`;

export const Option = styled.label`
  display: flex;
  flex-direction: column;
  margin-right: 20px;

  input {
    width: 20px;
    height: 20px;
    border-radius: 24px;
    border: 2px solid ${theme.community.coolGrey};
    cursor: pointer;
  }

  input:checked {
    box-shadow: inset 0 0 0 3px #ffffff;
    border: 2px solid ${theme.community.indigo};
    background-color: ${theme.community.indigo};
  }
  p {
    color: ${theme.community.stone};
  }
`;

export const PostOptionLabel = styled.p`
  font-family: Lato;
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  input {
    margin-right: 8px;
  }
`;

export const EventRadio = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const Label = styled.div`
  font-family: Lato;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  margin: 15px 0;
  display: flex;
  justify-content: space-between;
`;

export const Edit = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.community.indigo};
  text-decoration: underline;
  cursor: pointer;
`;

export const ExpertsBox = styled.div`
  border: 1px solid ${theme.community.paleGrey};
  border-radius: 8px;
  padding: 5px 10px;
  min-height: 40px;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
  align-items: center;
`;

export const ChooseExpert = styled.a`
  font-family: Lato;
  color: ${theme.community.indigo};
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
`;

export const ExpertsList = styled.div`
  font-family: Lato;
  border: 1px solid ${theme.community.paleGrey};
  border-radius: 8px;
  height: 370px;
  overflow: auto;
`;

export const Expert = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0 15px 15px;
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
`;

export const UserName = styled.div`
  margin: 0 5px;
  font-size: 14px;
  font-weight: 500;
  color: ${theme.community.darkNavy};
`;

export const Role = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.community.coolGrey};
`;

export const StyleCheckbox = styled.div`
  margin-left: auto;
`;

export const Description = styled.div`
  margin: 0 40px;
  font-size: 14px;
  font-weight: normal;
  color: ${theme.community.stone};
`;

export const HorizontalLine = styled.div`
  width: 100%;
  border-top: 1px solid ${theme.community.paleGrey};
`;

export const ExpertPill = styled.div`
  font-family: Lato;
  border: 1px solid ${theme.community.indigo};
  background-color: ${theme.community.mist};
  color: ${theme.community.indigo};
  border-radius: 20px;
  padding: 2px 10px;
  font-size: 14px;
  font-weight: 500;
  margin-right: 5px;
  margin-top: 5px;
  position: relative;
`;

export const StyledExpertPill = styled(ExpertPill)`
  &::after {
    content: url('/img/Close.svg');
    font-weight: 400;
    position: absolute;
    top: 45%;
    left: 64%;
    right: 0;
    bottom: 0;
    opacity: 0;
    transform: translate(-50%, -50%);
  }

  &:hover {
    background-color: rgba(70, 74, 201, 0.8);
    cursor: pointer;

    &::after {
      opacity: 1;
    }
  }
`;

export const RemovePreviewButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  vertical-align: top;
  background-color: ${theme.community.indigo};
  color: ${theme.text.reverse};
  border: none;
  border-radius: 100%;
  outline: none;
  padding: 4px;
  max-height: 24px;
  max-width: 24px;
  cursor: pointer;
  z-index: 1;

  &:hover {
    background-color: ${theme.warn.alt};
  }
`;

export const PreviewMedia = styled.div`
  position: relative;
  padding: 0;
  margin-bottom: 8px;
  height: auto;
  width: 200px;
  border-radius: 8px;
  margin-top: 13px;
  & + & {
    padding-top: 16px;

    ${RemovePreviewButton} {
      top: 16px;
    }
  }

  & > img {
    border-radius: 8px;
    max-width: 100%;
  }
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
`;

export const Section = styled.div`
  flex-basis: 50%;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  ${EventRadio}, .SingleDatePicker {
    width: 100%;
  }
  .DateInput_input__focused {
    border-bottom: 0;
  }
  .SingleDatePickerInput__block {
    display: flex;
    border: 2px solid #dfe7ef;
    border-radius: 4px;
    padding: 0;
    margin-right: 0.5rem;
  }
  .DateInput__block {
    margin-top: auto;
    margin-bottom: auto;
    flex-grow: 1;
  }
  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background: #4449c5;
    border: 1px double #4449c5;
    color: #fff;
  }
  .MuiSvgIcon-root {
    color: #a9acc1;
  }
  .DateInput_fang {
    display: none;
  }
`;

export const RowSection = styled(Section)`
  flex-wrap: nowrap;
`;

export const GreyText = styled.div`
  color: #73747d;
`;

export const SquareButton = styled(PrimaryButton)`
  width: 42px;
  border-radius: 4px;
`;

export const MediaLabel = styled.label`
  border: none;
  outline: 0;
  display: inline-block;
  background: transparent;
  transition: color 0.3s ease-out;
  color: ${theme.text.placeholder};
  height: 32px;
  width: 32px;

  &:hover {
    cursor: pointer;
    color: ${theme.brand.alt};
  }
`;

export const MediaInput = styled.input`
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: ${zIndex.hidden};
`;

export const ModeratorImage = styled.img`
  border-radius: 50%;
  vertical-align: middle;
  margin-left: 5px;
  width: 32px;
`;

export const ModeratorSelection = styled.button`
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const SelectOption = styled.span`
  margin-left: 7px;
  margin-right: 7px;
  color: ${props => props.color};
`;
